/**
 * navigation/navigationRef.ts
 * A container-level navigation ref so the app shell — the Sidebar and Command
 * Palette, which render *outside* the content navigator — can drive navigation
 * and read the active route. Screens rendered inside the stack use
 * useNavigation()/useRoute() directly and do NOT need this.
 */

import { createNavigationContainerRef } from '@react-navigation/native';
import type { AppStackParamList, AppRouteName } from './types';

export const navigationRef = createNavigationContainerRef<AppStackParamList>();

/** Navigate the app stack from outside a screen (no-op until the container mounts). */
export function navigateApp<Name extends AppRouteName>(
  name: Name,
  params?: AppStackParamList[Name],
): void {
  if (navigationRef.isReady()) {
    // Cast: the ref's overloads don't narrow well across the union of routes.
    (navigationRef.navigate as (n: Name, p?: AppStackParamList[Name]) => void)(name, params);
  }
}
